import { Flex, Heading, VStack } from '@chakra-ui/react';
import { colorScheme } from 'lib/colorScheme';
import React, { FunctionComponent, useState } from 'react';
import { moduleMaxWidth } from 'themes/overrides';
import { InbuiltFormData } from 'utils/types/formData';

import { InbuiltForm as InbuiltFormModal } from '../../models/content-types/inbuilt_form';
import { FormWrapper } from './FormWrapper';

interface InbuiltFormProps {
  model: InbuiltFormModal;
  onSubmit?: () => void;
}

export const InbuiltForm: FunctionComponent<InbuiltFormProps> = ({ model, onSubmit }) => {
  const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

  const formDataObj = JSON.parse(model.elements.hubspotFormSnippetForm.value);
  const headline = model.elements.headline.value;

  const backgroundColor = model.elements.backgroundColor.value;
  const bgColor = colorScheme[backgroundColor[0].codename as keyof typeof colorScheme].base;

  const data = {
    formId: formDataObj.FormGUID,
    portalId: formDataObj.PortalID,
    headline: headline,
    backgroundColor: bgColor,
    submittedMessageAlignment: 'center',
    fieldColor: bgColor === 'white' ? 'gray.98' : 'white',
  } as InbuiltFormData;

  return (
    <VStack
      w='100vw'
      maxW={moduleMaxWidth}
      mx='auto'
      align='stretch'
      id={model.system.codename}
      bg={data.backgroundColor}
      px={{ base: 'xs', md: 'l' }}
      spacing={{
        base: 's',
        md: 'm',
      }}
      mt='10px'
    >
      <Flex alignItems={'center'} w='100%' flexDir='column' p={{ base: 's', lg: 'l' }}>
        <Flex gap={{ base: 's', lg: 'm' }} flexDir='column' w={{ base: '100%', lg: '50%', xl: '60%' }}>
          {/* text */}
          {!hasBeenSubmitted && (
            <Heading textAlign={'center'} as='h1' color='#0098EB' textStyle={{ base: 'mobile.h4', lg: 'desktop.h4' }}>
              {data.headline}
            </Heading>
          )}
          {/* form */}
          <FormWrapper
            data={data}
            onSubmit={() => {
              setHasBeenSubmitted(true);
              if (onSubmit) {
                onSubmit();
              }
            }}
          />
        </Flex>
      </Flex>
    </VStack>
  );
};
